import { FormattedMessage } from '@flipster/i18n';
import { MaskedEmail } from '@flipster/react/design-utils/masking';
import CircleNoticeLineIcon from '@flipster/ui/assets/svgs/circle-notice-line.svg';

import styles from './verifyEmail.module.scss';

interface Props {
  email: string;
}

const VerifyEmail = ({ email }: Props) => {
  return (
    <div className={styles.wrapper}>
      <header>
        <h1>
          <FormattedMessage id='Autogen_common.r251126.s_Check_your_email' />
        </h1>
      </header>
      <p className={styles.pageDesc} translate='yes'>
        <FormattedMessage id='Autogen_common.r251126.s_Flipster_requires_verification_to_process_security_measures_Click_on_the_link_to_get_started' />
      </p>
      <div className={styles.verifyEmailWrapper}>
        <MaskedEmail email={email} />
      </div>
      <div className={styles.infoNotice}>
        <span className={styles.infoIcon}>
          <CircleNoticeLineIcon />
        </span>
        <p translate='yes'>
          <FormattedMessage id='Autogen_common.r251126.s_Please_confirm_your_email_in_24_hours_or_sign_up_will_be_canceled' />
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;
